module.exports = __webpack_public_path__ + "media/images/shapes/angles/angle-bottom-right-ba9edaa1941e1dd0b748635f3349e5fa.svg";